import { Link } from 'react-router-dom';
import { PhoneIcon, WhatsAppIcon } from './Icons';

export default function Header() {
  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: 'rgba(255,255,255,0.97)',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid var(--cream-dark)',
      height: '68px', display: 'flex', alignItems: 'center',
    }}>
      <div className="container" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%' }}>

        {/* Logo */}
        <Link to="/" style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <div style={{
            width:'38px', height:'38px', background:'var(--teal)',
            borderRadius:'9px', display:'flex', alignItems:'center',
            justifyContent:'center', color:'white', fontWeight:'800', fontSize:'19px',
            fontFamily:'Playfair Display, serif',
          }}>M</div>
          <div>
            <div style={{ fontFamily:'Playfair Display,serif', fontWeight:'700', fontSize:'17px', color:'var(--navy)', lineHeight:1.1 }}>
              MotionCare
            </div>
            <div style={{ fontSize:'10px', color:'var(--teal)', fontWeight:'600', letterSpacing:'1.2px', textTransform:'uppercase' }}>
              Physio
            </div>
          </div>
        </Link>

        {/* Right side */}
        <div style={{ display:'flex', alignItems:'center', gap:'16px' }}>
          <a
            href="tel:+97100000000"
            style={{ display:'flex', alignItems:'center', gap:'7px', fontSize:'14px', fontWeight:'600', color:'var(--navy)' }}
            className="hide-mobile"
          >
            <PhoneIcon size={15} color="var(--teal)" />
            +971 XX XXX XXXX
          </a>
          <a
            href="https://wa.me/97100000000?text=Hi,%20I'd%20like%20to%20book%20a%20home%20physiotherapy%20visit"
            target="_blank" rel="noopener noreferrer"
            style={{
              display:'flex', alignItems:'center', gap:'7px',
              background:'#25D366', color:'white',
              padding:'8px 16px', borderRadius:'50px',
              fontSize:'13px', fontWeight:'600',
            }}
            className="hide-mobile"
          >
            <WhatsAppIcon size={14} color="white" />
            WhatsApp
          </a>
          <Link to="/back-pain" style={{
            background:'var(--teal)', color:'white',
            padding:'9px 20px', borderRadius:'50px',
            fontSize:'13px', fontWeight:'600',
          }}>
            Request a Visit
          </Link>
        </div>
      </div>
    </header>
  );
}
